import { cn } from "@theprelude/core";

export const JamfIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.7957 3.90698C15.7184 3.90698 13.8781 5.18919 13.0333 7.99497L10.9063 14.6474C10.1219 16.8347 8.83972 17.7247 6.54683 17.7247H1.23696C0.573224 17.7247 0 18.2828 0 18.9617V22.3708C0 22.9893 0.4978 23.4871 1.17662 23.4871H22.763C23.4268 23.4871 24 22.929 24 22.2502V5.08359C24 4.41986 23.5022 3.90698 22.8234 3.90698H18.7957ZM1.28221 0C0.618479 0 0 0.618479 0 1.28221V10.3482C0 11.0723 0.55814 11.6304 1.28221 11.6304H5.86801C7.93463 11.6304 10.846 11.1779 11.6304 7.49717C11.6304 7.49717 12.4148 3.75613 12.8674 1.56883C13.0333 0.724074 12.4148 0 11.5852 0H1.28221Z" />
  </svg>
);
